export default import.meta.ROLLUP_FILE_URL_OB3mTkXOrF3rLDB7Ssxv6g